import { twMerge } from "tailwind-merge";

export const CircularImage = ({
  src,
  alt,
  size,
  className,
}: {
  src: string;
  alt: string;
  size: number;
  className?: string;
}) => {
  return (
    <img
      src={`${src}?h=100&w=100&auto=compress&fit=crop`}
      alt={alt}
      className={twMerge(
        "rounded-full object-cover mix-blend-multiply",
        className,
      )}
      style={{
        height: size,
        width: size,
      }}
    />
  );
};
